/*
 * Copyright (c) 2022-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Deserializable} from './deserializable';
import {ErrorMessage} from './errorMessage';

export class ResponseWrapper implements Deserializable {

  success: boolean;
  errorMessages: ErrorMessage;
  length: number;
  data: any;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
